import React, { useEffect, useState } from "react";
import { MoonSVG, SunSVG } from "../../utils/svgs";
import useProjectInfo from "../../hooks/useProjectinfo";

const ThemeSwitchButton = () => {
  const { onToggleTheme } = useProjectInfo();
  return (
    <div
      className="w-[91px] h-[44px] rounded-[100px] cursor-pointer bg-primary dark:bg-secondary flex justify-between items-center text-white px-1.5 relative transition-all"
      onClick={() => onToggleTheme()}
    >
      <div>{SunSVG}</div>
      <div>{MoonSVG}</div>
      <div className="w-9 h-9 rounded-full bg-white absolute left-1 top-1 transition-all dark:left-[51px]" />
    </div>
  );
};

export default ThemeSwitchButton;
